<template>
  <div v-if="hasDrivers">
    <table class="table table-borderless table-border table-align table-h51">
      <thead>
      <tr>
        <th>
          <BkpsCheckBox @input="$emit('changeCheckAllRow', $event)" :value="checkAllRow"/>
        </th>
        <th>CPF</th>
        <th>Nome</th>
        <th>Telefone</th>
        <th>Categoria do Motorista</th>
        <th>CNH</th>
        <th>Criado em</th>
        <th>Atualizado em</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="driver in drivers" :key="driver.id">
        <td>
          <BkpsCheckBox v-model="driver.checked" @input="$emit('changeCheckRow', $event)"/>
        </td>
         <td>{{ driver.cpf | cpf }}</td>
         <td>{{ driver.name }}</td>
         <td>{{ driver.phone | phone }}</td>
         <td>{{ driver.category }}</td>
         <td>
           <span :class="driver.cnhFileAttached ? 'badge-success' : 'badge-secondary'" class="badge">
             {{ driver.cnhFileAttached ? 'Anexado' : 'Pendente' }}
           </span>
         </td>
         <td>{{ driver.createdAt | datetime }}</td>
         <td>{{ driver.updatedAt | datetime }}</td>
        <td class="text-right">
          <button @click="$emit('showDriver', driver)" class="btn-icon btn-outline">
            <edit-icon size="1.5x"/>
          </button>

          <button
              v-if="$withPolicy('application', 'drivers/delete')"
              @click="$emit('sendDeleteDriver', driver)"
              class="btn-icon btn-outline-red ml-2 mr-3"
          >
            <trash-2-icon size="1.5x"/>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <p class="mt-4">
      {{ getUser.role === 'owner' ? 'Nenhum motorista cadastrado' : 'Nenhum motorista cadastrado ou você não possui acesso' }}
    </p>
  </div>

</template>

<script>

  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import getUser from '@/mixins/GetUser.vue'
  import { EditIcon, Trash2Icon } from 'vue-feather-icons'

  export default {
    components: { BkpsCheckBox, EditIcon, Trash2Icon },
    mixins: [ getUser ],
    name: 'Table',
    props: {
      checkAllRow: { required: true, type: Boolean },
      drivers: { required: true, type: Array }
    },
    computed: {
      hasDrivers() {
        return this.drivers.length > 0
      },
    },
  }
</script>

<style scoped>
.badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}
</style>
